import { Link } from "react-router-dom";

// items: [{ label: string, to?: string }]
const Breadcrumbs = ({ items = [] }) => {
	if (!items.length) return null;

	return (
		<nav
			className="mb-2 text-xs text-muted-foreground"
			aria-label="Breadcrumb"
			itemScope
			itemType="https://schema.org/BreadcrumbList"
		>
			<ol className="flex flex-wrap items-center gap-1">
				{items.map((item, index) => {
					const isLast = index === items.length - 1;
					const position = index + 1;

					return (
						<li
							key={`${item.label}-${index}`}
							className="flex items-center gap-1"
							itemProp="itemListElement"
							itemScope
							itemType="https://schema.org/ListItem"
						>
							{item.to && !isLast ? (
								<Link
									to={item.to}
									className="hover:text-foreground transition-colors"
									itemProp="item"
								>
									<span itemProp="name">{item.label}</span>
								</Link>
							) : (
								<span className="text-foreground" itemProp="name">
									{item.label}
								</span>
							)}
							<meta itemProp="position" content={String(position)} />
							{!isLast && <span className="opacity-60">/</span>}
						</li>
					);
				})}
			</ol>
		</nav>
	);
};

export default Breadcrumbs;
